var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("contactModuleRules.ruleTester.title"),
        width: "700px",
        footer: null,
        bodyStyle: { padding: "24px" },
      },
      on: { cancel: _vm.onCancel },
    },
    [
      _c("div", { staticClass: "rule-tester" }, [
        _c("div", { staticClass: "tester-header" }, [
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("contactModuleRules.ruleTester.description")) +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tester-body" }, [
          _c(
            "div",
            { staticClass: "rule-selector" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("contactModuleRules.ruleTester.selectRule"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t(
                      "contactModuleRules.ruleTester.selectRulePlaceholder"
                    ),
                  },
                  model: {
                    value: _vm.selectedRuleId,
                    callback: function ($$v) {
                      _vm.selectedRuleId = $$v
                    },
                    expression: "selectedRuleId",
                  },
                },
                _vm._l(_vm.rules, function (rule) {
                  return _c(
                    "a-select-option",
                    { key: rule.id, attrs: { value: rule.id } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(rule.name) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "test-action" },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    size: "large",
                    loading: _vm.testing,
                    disabled: !_vm.selectedRuleId,
                    block: "",
                  },
                  on: { click: _vm.runTest },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("play_arrow"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("contactModuleRules.ruleTester.test")) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.testResult
            ? _c(
                "div",
                { staticClass: "test-results" },
                [
                  _c(
                    "a-alert",
                    {
                      attrs: {
                        message: _vm.$t(
                          "contactModuleRules.ruleTester.ruleInfo"
                        ),
                        type: "info",
                        "show-icon": "",
                      },
                    },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "rule-info" }, [
                          _c("div", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("contactModuleRules.when"))),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.testResult.info.when === "contact_created"
                                    ? _vm.$t(
                                        "contactModuleRules.whenContactCreated"
                                      )
                                    : _vm.$t(
                                        "contactModuleRules.whenChatOpened"
                                      )
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "contactModuleRules.ruleTester.conditionCount"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.testResult.info.conditionCount)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "contactModuleRules.ruleTester.actionCount"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.testResult.info.actionCount)
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }